import React, { useState } from 'react';
import { toast } from 'sonner';
import { Download, Loader2, Gavel } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const FALLO = { acoge: 'Acoge', rechaza: 'Rechaza', acoge_parcialmente: 'Acoge parcialmente' };
const RES = { 'ganó': 'text-emerald-300', 'perdió': 'text-red-300', neutral: 'text-slate-300' };

export const TrialVerdict = ({ session }) => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(false);
  const v = session.verdict;
  const pdf = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/trial-sim/${session.id}/pdf`, { responseType: 'blob' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = `Simulación de juicio - ${session.title.slice(0, 50)}.pdf`; a.click();
    } catch { toast.error('No se pudo generar el PDF'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="trial-verdict">
      <div className="flex items-center justify-between rounded-xl border border-amber-500/40 bg-amber-500/10 p-4">
        <div><p className="text-xs text-amber-200">Sentencia simulada</p><p data-testid="trial-verdict-fallo" className="text-lg font-bold text-white flex items-center gap-2"><Gavel className="h-5 w-5 text-amber-400" />{FALLO[v.fallo] || v.fallo}</p></div>
        <div className="text-right"><p className="text-xs text-amber-200">Probabilidad de victoria</p><p data-testid="trial-verdict-prob" className="text-3xl font-bold text-white">{v.probabilidad_victoria}%</p></div>
      </div>
      <p className="text-sm text-slate-200">{v.decision}</p>
      <div><p className="text-xs font-semibold text-sky-300 mb-1">Razonamiento del tribunal</p>{v.razonamiento?.map((r, i) => <p key={i} className="text-xs text-slate-300">{i + 1}. {r}</p>)}</div>
      <div data-testid="trial-verdict-stages"><p className="text-xs font-semibold text-white mb-1">Dónde ganaste o perdiste puntos</p>
        {v.por_etapa?.map((e, i) => <p key={i} className="text-xs text-slate-300"><span className={RES[e.resultado] || 'text-slate-300'}>{e.puntos} · {e.etapa}</span> — {e.motivo}</p>)}</div>
      <div><p className="text-xs font-semibold text-emerald-300 mb-1">Qué reforzar antes del juicio real</p>{v.reforzar?.map((r, i) => <p key={i} className="text-xs text-slate-300">• {r}</p>)}</div>
      {v.recurso_probable && <p className="text-xs text-slate-400"><span className="text-white">Recurso probable:</span> {v.recurso_probable}</p>}
      <button data-testid="trial-verdict-pdf" onClick={pdf} disabled={busy} className="w-full rounded-lg bg-amber-500 py-2 text-sm font-semibold text-slate-950 hover:bg-amber-400 disabled:opacity-60 flex items-center justify-center gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}Descargar informe PDF
      </button>
      <p className="text-[10px] text-slate-500">{v.disclaimer}</p>
    </div>
  );
};
